<template>
  <div style="z-index: 1">
    <block v-if="loading" />
    <div
      class="white"
      style="
        border-radius: 10px;
        padding: 20px;
        padding-top: 50px;
        margin-bottom: 20px;
        border: 1px solid;
        border-color: black;
      "
    >
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="provider.ProviderName"
            outlined
            dense
            label="Proveedor"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="provider.ProviderLegalAddress"
            outlined
            dense
            label="Dirección legal"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-select
            v-model="provider.ProviderLegalSector"
            :items="activities"
            outlined
            dense
            label="Actividad economica"
            item-text="Valores"
            item-value="Codigo"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="provider.ProviderLegalTaxPayerSize"
            outlined
            dense
            label="Tamaño de contribuyente"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="provider.ProviderLegalEntity"
            outlined
            dense
            label="Entidad jurídica"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="provider.ProviderLegalNRC"
            outlined
            dense
            label="NRC Legal"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
            v-model="provider.ProviderLegalNIT"
            outlined
            dense
            label="NIT Legal"
            disabled
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-btn class="btn-save mb-1" @click="showExpenseSuppliers = true"
            >Buscar proveedores</v-btn
          >
        </v-col>

        <v-col cols="12" md="3">
          <v-checkbox
            v-model="provider.LegalAgentRetain"
            label="Es agente de retención 1%"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-checkbox
            v-model="provider.LegalReteRenta"
            label="Retiene 10% renta"
          />
        </v-col>
        
        <v-col cols="12" md="3" v-show="!percentageIvaCheck">
          <v-checkbox v-model="percentageIvaCheck" label="Solo tomar % IVA"></v-checkbox>
        </v-col>
        <v-col cols="12" md="3" v-show="percentageIvaCheck">
          <v-text-field
            v-model="percentageIva"
            outlined
            dense
            label="Porcentaje de IVA"
          >
            <template v-slot:prepend>
              <v-checkbox v-model="percentageIvaCheck"></v-checkbox>
            </template>
          </v-text-field>
        </v-col>

      </v-row>
      <CustomCSVPeriod @customCSVPeriod="setCustomCSVPeriod" @year="setCustomCSVPeriodYear" @month="setCustomCSVPeriodMonth" :cleanState="cleanState" @resetCleanState="() => cleanState = false" :submitState="submitCustomCSVPeriodState" />
      <v-row>
        <v-col cols="12" md="6">
          <h3 :class="showBgcolorNotes" style="text-align: center; margin-bottom: 10px;" @click="showComments = !showComments">
            Notas internas de la factura
          </h3>
        </v-col>
        <v-col cols="12" md="6">
          <h3 class="tabs" style="text-align: center" @click="showInfoInvoice = !showInfoInvoice">
            Datos de la factura del proveedor
          </h3>
        </v-col>
      </v-row>
    </div>

    <!-- Add ExpenseCode -->
    <div class="white box pa-6">
      <v-row style="margin-top: 1rem; margin-bottom: 1rem;">
        <v-col cols="12" md="2">
          <v-btn @click="addAccountingCode()" class="btn-save">
            Buscar cuenta
          </v-btn>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field dense outlined label="Código contable seleccionado" v-model="account.AccountCode" disabled></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field dense outlined label="Cuenta contable seleccionada" v-model="account.CatalogName" disabled></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn @click="asignAccountingCode()" class="btn-save">
            Asignar a todos
          </v-btn>
        </v-col>
      </v-row>
      
      <v-row class="mb-4" style="padding: 0 10px;">
        <v-col cols="4" md="1" sm="2" xs="4">
          <v-btn class="btn-save" @click="addExpense2">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
        <v-col v-if="invoice.InvoiceType == 'FE'" cols="12" md="3">
          <v-select
          outlined
          dense
          v-model="invoice.CodDocAsociado"
          attach
          :items="codigosAsociadosEx"
          item-value="id"
          item-text="valor"
          label="Código de documento asociado *"
          :rules="required"
          required
          >
          </v-select>
        </v-col>
        <v-col v-if="invoice.InvoiceType == 'FE'" cols="12" md="3">
          <v-text-field
          v-model="invoice.DocAsociado"
          dense
          outlined
          label="Documento asociado *"
          :rules="required"
          required
          ></v-text-field>
        </v-col>
        <v-col v-if="invoice.InvoiceType == 'FE'" cols="12" md="3">
          <v-text-field
          v-model="invoice.DetalleDocAsociado"
          dense
          outlined
          label="Detalle de documento asociado *"
          :rules="required"
          required
          ></v-text-field>
        </v-col>
        <v-col v-if="invoice.InvoiceType == 'FE'" cols="12" md="1">
          <v-text-field
          v-model="flete"
          type="number"
          dense
          outlined
          label="Flete *"
          :rules="required"
          required
          ></v-text-field>
        </v-col>
        <v-col v-if="invoice.InvoiceType == 'FE'" cols="12" md="1">
          <v-text-field
          v-model="seguro"
          type="number"
          dense
          outlined
          label="Seguro *"
          :rules="required"
          required
          ></v-text-field>
        </v-col>
        <!--v-col v-if="invoice.InvoiceType == 'CCF' || invoice.InvoiceType == 'NC'" cols="12" md="3">
          <v-checkbox
          v-model="costUniSinIva"
          label="Ingresar costo unitario sin IVA"
          ></v-checkbox>
        </v-col-->
      </v-row>
      <!-- Add ExpenseCode -->
      <!-- Table -->
          <DxDataGrid
            ref="gridContainer"
            :data-source="incomeExpenses"
            :show-row-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            @row-updated="calculateTotalOnEnter()"
            :scrolling="{useNative: true}"
            :column-auto-width="true"
            width="100%"
          >
            <DxEditing :allow-updating="true" mode="cell" />
          
            <DxPaging :page-size="10" />
            <DxColumn
              :allow-editing="false"
              data-field="AccountCode"
              caption="Código de gasto"
              :width="columnWidth"
            ></DxColumn>
            <DxColumn
              :allow-editing="false"
              cell-template="accounting-code"
              caption="Cuenta Contable"
            ></DxColumn>
            <template #accounting-code="{ data }">
              <div>
                <template v-if="data.data.CatalogName">
                  <a href="#" @click="addAccountingCodeByItem(data.data)">
                    <v-icon>mdi-eye</v-icon>
                  </a>
                  {{ data.data.CatalogName }}
                </template>
                <template v-else>
                  <a href="#" @click="addAccountingCodeByItem(data.data)">
                    <v-icon>mdi-eye</v-icon>
                  </a>
                </template>
              </div>
            </template>
            <DxColumn
              cell-template="type-template"
              caption="Tipo de gasto"
              width="250"
            ></DxColumn>
            <template #type-template="{ data }">
              <div>
                <div style="width: 100%">
                  <select
                  style="width: calc(100% - 30px); padding: 5px"
                  v-model="data.data.ExpenseType"
                  >
                    <option value="product">Producto</option>
                    <option value="service">Servicio</option>
                  </select>
                  <v-icon>mdi-arrow-down</v-icon>
                </div>
              </div>
            </template>
            <DxColumn
              :allow-editing="true"
              data-field="ExpenseName"
              caption="Nombre de Gasto"
              width="250"
            ></DxColumn>
            <DxColumn
              data-type="number"
              data-field="quantity"
              caption="Cantidad"
              :width="columnWidth"
            >
              <DxPatternRule
                :pattern="itemQtyPatternOne"
                message="La cantidad solo puede contener números enteros mayores a 0 y 2 decimales."
              />
            </DxColumn>
            <DxColumn
              data-type="number"
              data-field="pricePerUnit"
              caption="Precio Unitario"
              :width="columnWidth"
            >
              <DxPatternRule
                :pattern="itemQtyPatternOne"
                message="La cantidad solo puede contener números enteros mayores a 0 y 2 decimales."
              />
            </DxColumn>
            <DxColumn
              :width="columnWidth"
              cell-template="itemDeclarationTypeSelect"
              caption="Gasto Declarable como:"
            ></DxColumn>
            <DxColumn
              :allow-editing="false"
              cell-template="IsExento"
              caption="Exento"
              :width="100"
            ></DxColumn>
            <template #IsExento="{ data }">
              <input type="checkbox" @click="data.data.IsNoSujeto = false; removeIva(data.data)" v-model="data.data.IsExento" />
            </template>

            <DxColumn
              :allow-editing="false"
              cell-template="IsNoSujeto"
              caption="No Sujeto"
              :width="100"
            ></DxColumn>
            <template #IsNoSujeto="{ data }">
              <input type="checkbox" @click="data.data.IsExento = false; removeIva(data.data)" v-model="data.data.IsNoSujeto" />
            </template>

            <DxColumn
              :allow-editing="false"
              cell-template="IsHidrocarburo"
              caption="Hidrocarburo"
              :width="100"
            ></DxColumn>
            <template #IsHidrocarburo="{ data }">
              <input type="checkbox" @change="calculateHidrocarburo()" v-model="data.data.IsHidrocarburo" />
            </template>

            <DxColumn
              :allow-editing="false"
              data-field="total"
              caption="Total"
              :width="columnWidth"
            ></DxColumn>
            <DxColumn
            :width="columnWidth"
              :allow-editing="false"
              cell-template="delete-template"
              caption=""
            ></DxColumn>
            <template #total-template="{ data }">
              {{ rowTotal(data.data) }}
            </template>
            <template #delete-template="{ data }">
              <a class="mx-1" @click="removeRow(data.data)">
                <v-icon color="error">mdi-delete</v-icon>
              </a>
            </template>
            <template #itemDeclarationTypeSelect="{ data }">
              <span class="scroll-fixing-purchase">
                <select
                  style="width: calc(100% - 30px); padding: 5px"
                  class="form-control custom-select"
                  v-model="data.data.ItemDeclarationType"
                >
                  <option v-for="item in tipoItemCompraGasto" :value="item.Codigo" :key="item.Codigo">
                    {{ item.Valores }}
                  </option>
                </select>
                <v-icon>mdi-arrow-down</v-icon>
              </span>
            </template>
          </DxDataGrid>
        <!--/GeneralFilter-->
      
      <!-- Table -->

      <v-row class="my-5 d-flex justify-center align-center">
        <!-- Shadow footer -->
        <diV class="box" :class="isDrawerOn ? 'minimize' : 'maximize'" style="width: 100%;">
          <v-row class=" my-1 d-flex justify-center align-center">
            
            <div class="break-line"></div>
            <v-col cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Subtotal</span>
                <input
                  type="text"
                  class="formControl"
                  :value="subTotal"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col v-if="invoice.InvoiceType == 'CCF' || invoice.InvoiceType == 'NC'" cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Iva</span>
                <input
                  type="text"
                  class="formControl"
                  :value="iva"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Exentas</span>
                <input
                  type="text"
                  class="formControl"
                  :value="exentas"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">No sujetas</span>
                <input
                  type="text"
                  class="formControl"
                  :value="nosujetas"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col v-if="reterenta > 0" cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Rete renta</span>
                <input
                  type="text"
                  class="formControl"
                  :value="reterenta"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col v-if="ivaret > 0" cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">IVA Ret.</span>
                <input
                  type="text"
                  class="formControl"
                  :value="ivaret"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col v-if="ivaperc > 0" cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">IVA Perc.</span>
                <input
                  type="text"
                  class="formControl"
                  :value="ivaperc"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col v-if="fovial > 0" cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Fovial</span>
                <input
                  type="text"
                  class="formControl"
                  :value="fovial"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <v-col v-if="cotrans > 0" cols="1" xxl="1" xl="1" lg="1" md="1" sm="1" xs="1" class="d-flex justify-center spaced">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Cotrans</span>
                <input
                  type="text"
                  class="formControl"
                  :value="cotrans"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <div class="break-line2"></div>
            <v-col cols="2" xxl="2" xl="2" lg="2" md="2" sm="2" xs="2" class="d-flex justify-center" style="margin-right: 10px;">
              <div class="d-flex flex-column justify-center">
                <span class="text-center totalText">Total</span>
                <input
                  type="text"
                  class="totalDesign formControl"
                  :value="grandTotal"
                  disabled
                  aria-describedby="VENTAS-TOTAL"
                />
              </div>
            </v-col>
            <div class="break-line"></div>
            <v-col cols="2" xxl="2" xl="2" lg="2" md="2" sm="2" xs="2" class="d-flex justify-center">
              <v-btn class="text-uppercase btnclean mx-5" @click.prevent="clear">
                <v-icon>mdi-broom</v-icon>
              </v-btn>
              <Button 
                v-if="invoice.InvoiceType != 'FNS' && $store.getters['rolesUser/getCustomRole'](217)"
                class="mx-5 btn-save"
                title="Guardar ingreso de gasto" 
                :throttleTime="500"
                @click.prevent="confirmationBeforeSave"
                :disabled="loading"
              >
                <v-icon>mdi-content-save</v-icon>
              </Button>
              <Button 
                v-if="invoice.InvoiceType == 'FNS' && $store.getters['rolesUser/getCustomRole'](217)"
                class="mx-5"
                title="Guardar ingreso de gasto" 
                color="success"
                :throttleTime="500"
                @click.prevent="beforeSaveExpenseEntryFns" 
                :disabled="loading"
              >
                <v-icon>mdi-content-save</v-icon>
              </Button>
            </v-col>
            <div class="break-line"></div>
          </v-row>
        </diV>
        <!-- Shadow footer -->
      </v-row>

    </div>

    

    <!-- Dialog -->
    <v-dialog v-model="showComments" width="90%">
      <v-card class="border" style="height: 70%;">
        <v-btn @click="showComments = false" elevation="0" color="red" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="text-h5">Notas internas de la factura</v-card-title>
        <v-card-text style="height: 80%;">
          <quill-editor
          style="height: 80%;"
          :content="invoice.InvoiceComment"
          @change="onEditorChange($event)"
          ></quill-editor>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn @click="showComments = !showComments" class="btndisable">
              Continuar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog -->
    <v-dialog v-model="showInfoInvoice" width="70%" scrollable>
      <v-card class="border "  width="100%" height="500">
        <v-btn @click="showInfoInvoice = false" elevation="0"  width="64px" color="red" class="close-btn align-self-end">
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-card-title class="text-h5">Datos de la factura</v-card-title>
        <v-card-text>
            <v-row class="mt-6 ml-2 mr-2 mb-6">
              <v-col cols="12" md="3">
                <center>
                  <v-img :src="url" width="100px" height="100px" class="preview-avatar"></v-img>
                </center>
                <v-file-input @change="Preview_image" v-model="image" label="Imágen de Factura" prepend-icon="mdi-camera" placeholder="Imágen de Factura" :rules="[maxFileSize]"></v-file-input>
              </v-col>

              <v-col cols="12" md="9">
                <v-row>
                  <v-col cols="12" md="6">
                    <date-picker label="Fecha de la Factura" v-model="invoice.InvoiceDate"
                    @dateSelected="(param) => (invoice.InvoiceDate = param)"></date-picker>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select outlined dense :items="catalogTypedocument" attach label="Tipo de Factura" v-model="invoice.InvoiceType" required
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete v-if="invoice.InvoiceType != 'FNS'" outlined dense v-model="invoice.InvoiceDocumentType"
                      :items="documentOptions" :items-value="value" :items-text="text" attach
                      label="Tipo de documento" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-if="invoice.InvoiceType != 'FNS'" outlined dense v-model="invoice.InvoiceCorrelative" required 
                      :label="invoice.InvoiceDocumentType == '2' ? 'Código de generación' : 'Correlativo de factura'"></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="invoice.InvoiceType == 'NC'">
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      v-model="invoice.NumeroDocumentoRelacionado"
                      label="Codigo de generación Documento Relacionado"
                      hint="Codigo de generación al que hace referencia esta nota de crédito"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-text-field v-if="invoice.InvoiceType != 'FNS'" outlined dense v-model="invoice.NumeroControl" 
                      label="Número de control"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-if="invoice.InvoiceType != 'FNS'" outlined dense v-model="invoice.SelloRecibido" 
                      label="Sello Recibido"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-model="invoice.InvoicePaymentMethod"
                      :items="paymentTypes" item-text="Valores" attach label="Método de Pago" required></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-model="invoice.InvoiceState" :items="invoiceStatus"
                      label="Estado de la Factura" attach required></v-autocomplete>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" v-if="invoice.InvoicePaymentMethod != 'Billetes y monedas'">
                    <v-text-field 
                      v-if="invoice.InvoicePaymentMethod != 'Billetes y monedas'" 
                      outlined dense
                      v-model="invoice.InvoiceReference" label="N. Referencia" />
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-autocomplete outlined dense v-if="invoice.InvoiceState == 'Crédito'"
                      v-model="invoice.InvoiceDays" :items="days" label="Plazo" attach></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- Clasificación para anexos -->
            <v-row class="mt-6 ml-2 mr-2">
              <v-col cols="12">
                <v-card outlined class="pa-4">
                  <h3 class="mb-6">Clasificación para anexos</h3>
                  <v-row>
                    <v-col cols="12" md="4">
                      <ClasificationRentaAutocomplete 
                        v-model="invoice.ClasificationRent" 
                        required
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        outlined
                        dense
                        v-model="invoice.SectorProveedores"
                        :items="sectorProveedores"
                        item-text="Valores"
                        item-value="Codigo"
                        attach
                        clearable
                        label="Sector"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        outlined
                        dense
                        v-model="invoice.TipoIngresoProveedores"
                        :items="tipoIngresoProveedores"
                        item-text="Valores"
                        item-value="Codigo"
                        attach
                        clearable
                        label="Tipo de Costo / Gasto"
                      ></v-select>
                    </v-col>
                    <v-col>
                      <small>Los campos <b>Tipo de Costo / Gasto</b> y <b>Sector</b> son opcionales; si no se seleccionan, se tomarán los valores predeterminados del proveedor.</small>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog -->
    <v-dialog v-model="showExpenseSuppliers" scrollable width="70%">
      <v-card class="border">
        <v-btn @click="showExpenseSuppliers = false" elevation="0" color="red" class="close-btn align-self-end"><v-icon>mdi-close</v-icon></v-btn>
        <v-card-title>Proveedores de gastos</v-card-title>
        <v-card-text>
          <ProvidersTable
            icon="plus"
            :newProviders="providers"
            @handleProvider="addProvider"
          />
          <div class="d-flex justify-end">
            <v-btn @click="showExpenseSuppliers = false" class="btndisable">
              Continuar
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog -->

    <!-- Dialog -->
    <v-dialog v-model="showExpenses" scrollable width="60%">
      <v-card class="border">
        <v-btn @click="showExpenses = false" elevation="0" color="red" class="close-btn align-self-end"><v-icon>mdi-close</v-icon></v-btn>
        <v-card-title>Gastos</v-card-title>
        <v-card-text>
          <ExpenseTable icon="plus" :newExpenses="expenses" @handleExpense="addExpense" />
          <div class="d-flex justify-end">
            <v-btn @click="showExpenses = false" class="btndisable"> Continuar </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showAccountingForm" scrollable width="70%">
      <ExpenseDialog
      :win="win"
      :newAccountList="accountList"
      :newSelectedExpense="selectedExpense"
      :action="action"
      @handleAction="handleAction"
      />
    </v-dialog>
    <!-- Dialog -->

    <!-- Alert -->
    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
      class="deep-alert"
    >
    </alerts>
    <print-pos-fa
      :dataProps="print2"
      @mailSent="
        () => {
          showAlert(
            'success',
            'Correo enviado',
            'Se ha enviado el detalle de la factura correctamente'
          );
        }
      "
    ></print-pos-fa>
    <!-- Alert -->
  </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";
//import GeneralFilter from "@/components/GeneralFilter";
import ExpenseTable from "../ExpenseTable.vue";
import ProvidersTable from "../ExpenseProvidersTable.vue";
import DatePicker from "../../../components/DatePicker";
import ExpenseDialog from "../ExpenseDialog.vue";
import { mapGetters } from "vuex";
import { numberToText } from "../../../helpers/conveterNumberText";
import PrintPosFa from "@/components/ReportsAndPrintings/PrintPosFa";
import CustomCSVPeriod from "@/components/Misc/CustomCSVPeriod.vue";
import Button from "@/components/Button.vue";

import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxPatternRule
} from "devextreme-vue/data-grid";
import ClasificationRentaAutocomplete from "../../../components/Misc/ClasificationRentaAutocomplete.vue";
import moment from "moment";

export default {
  name: "ExpenseManagmentEntry",

  components: {
    DxDataGrid,
    DxColumn,
    ExpenseDialog,
    DxPaging,
    //GeneralFilter,
    ExpenseTable,
    ProvidersTable,
    DxEditing,
    DxPatternRule,
    Alerts,
    Block,
    DatePicker,
    PrintPosFa,
    CustomCSVPeriod,
    ClasificationRentaAutocomplete,
    Button
  },

  props: ["win"],

  data() {
    return {
      itemQtyPatternOne: /^(0|[1-9]\d*)(\.\d+)?$/, ///^(0*[1-9][0-9]*(\.[0-9]{1,2})?|0+\.[0-9]*[1-9][0-9]*)$/,
      itemQtyPatternTwo: /^(0*[1-9][0-9]*)$/,
      showComments: false,
      showInfoInvoice: false,
      showExpenseSuppliers: false,
      submitCustomCSVPeriodState: false,
      showExpenses: false,
      expenses: null,
      providers: null,
      provider: {},
      percentageIvaCheck: false,
      percentageIva: 50,
      insertCode: null,
      suppliers: null,
      incomeExpenses: [],
      search: {
        filter: null,
      },
      invoice: {
        InvoiceDate: moment().format("DD/MM/YYYY"),
        InvoiceType: "",
        InvoiceCorrelative: "",
        NumeroControl: "",
        SelloRecibido: "",
        InvoiceDocumentType: "",
        InvoicePaymentMethod: "",
        InvoiceState: "",
        InvoiceComment: "",
        InvoiceDays: "",
        NumeroDocumentoRelacionado: "",
        ID_AccountCatalog: null,
        TipoIngresoProveedores: null,
        SectorProveedores: null,
        ClasificationRent: '2',
      },
      image: null,
      url: null,
      grandTotal: parseFloat(0).toFixed(2),
      subTotal: parseFloat(0).toFixed(2),
      exentas: parseFloat(0).toFixed(2),
      nosujetas: parseFloat(0).toFixed(2),
      iva: parseFloat(0).toFixed(2),
      reterenta: parseFloat(0).toFixed(2),
      ivaret: parseFloat(0).toFixed(2),
      ivaperc: parseFloat(0).toFixed(2),
      fovial: parseFloat(0).toFixed(2),
      cotrans: parseFloat(0).toFixed(2),
      flete: parseFloat(0).toFixed(2),
      seguro: parseFloat(0).toFixed(2),
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      loading: false,
      showBgcolorNotes: "tabs",
      catalogTypedocument: [],
      documentOptions: [
        { value: "1", text: "Físico" },
        { value: "2", text: "Electrónico" },
      ],
      paymentMethod: [
        "Efectivo",
        "Cheque",
        "Transferencia",
        "Tarjeta de Crédito",
        "Otro",
      ],
      invoiceStatus: ["Cancelada", "Crédito", "Anulada"],
      days: ['8 Dias', '15 Dias', '30 Dias', '90 Dias', '120 Dias', '180 Dias'],
      validImageSize: true,
      taxPayerSize: null,
      BusinessLegalAgentRetain: false,
      accountList: {},
      selectedExpense: {
        ExpenseName: null,
        ID: null,
        CatalogName: null,
      },
      showAccountingForm: false,
      action: {
        ADD: false,
        EDIT: false,
        DEL: false,
        ADD_ONE: false,
      },

      expenseIdCounter: 1,
      account: {},
      required: [(v) => !!v || "Este campo es requerido"],
      codigosAsociadosEx: [
        {
          id: 4,
          valor: "Transporte",
        },
        {
          id: 1,
          valor: "Emisor",
        },
        {
          id: 2,
          valor: "Receptor",
        },
      ],
      datatoprint: {
        branch: JSON.parse(localStorage.getItem("branch")),
        user: JSON.parse(localStorage.getItem("user")),
        header: null,
        body: null,
        dteJson: null,
      },
      print2: {
        show: false,
        data: [],
      },
      cleanState: false,
      CustomCSVPeriodFlag: false,
      CustomCSVPeriodYear: null,
      CustomCSVPeriodMonth: null
      //costUniSinIva: false,
    };
  },

  mounted() {
    this.getAllExpense();
    this.getAllProviders();
    this.getCatalogTypedocument();
    this.getInfoBranch();
    this.getAllAcounts();
  },

  watch: {
    incomeExpenses: {
      handler: "calculateGrandTotal",
      deep: true,
    },
    "invoice.InvoiceType": {
      deep: true,
      immediate: true,
      handler() {
        this.calculateGrandTotal();
      } 
    },
    flete: {
      deep: true,
      immediate: true,
      handler() {
        this.calculateGrandTotal();
      } 
    },
    seguro: {
      deep: true,
      immediate: true,
      handler() {
        this.calculateGrandTotal();
      } 
    },
    "provider.ProviderLegalTaxPayerSize"() {
      this.calculateGrandTotal()
    },
    "provider.LegalReteRenta"() {
      this.calculateGrandTotal()
    },
    "provider.LegalAgentRetain"() {
      this.calculateGrandTotal()
    },
    /*costUniSinIva: {
      deep: true,
      immediate: true,
      handler() {
        this.calculateTotalOnEnter();
        this.calculateGrandTotal();
      }
    }*/
  },

  computed: {
    ...mapGetters(["getCatalogMH"]),
    tipoItemCompraGasto() {
      return this.getCatalogMH("TipoItemCompraGasto");
    },
    columnWidth() {
      return "150px" 
    },
    expensesNameAndCode() {
      return this.expenses
        ? this.expenses.map((item) => ({
            labelName: `${item.ID_Admin_Expenses} - ${item.ExpenseName}`,
            ...item,
          }))
        : [];
    },
    isDrawerOn() {
      return this.$store.getters.getDrawerMini;
    },
    activities() {
      return this.getCatalogMH("ActividadEconomica");
    },
    paymentTypes() {
      return this.getCatalogMH("FormaPago");
    },
    tipoIngresoProveedores() {
      return this.getCatalogMH('TipoIngresoProveedores');
    },
    sectorProveedores() {
      return this.getCatalogMH('SectorProveedores');
    },
  },

  methods: {
    asignAccountingCode() {
      if (this.account) {
        for (let item of this.incomeExpenses) {
          item.ID_AccountCatalog = this.account.ID_AccountCatalog
          item.CatalogName = this.account.CatalogName
          item.AccountCode = this.account.AccountCode
        }
      }
    },  
    setCustomCSVPeriod(val){
      this.CustomCSVPeriodFlag = val
    },
    setCustomCSVPeriodYear(val){
      this.CustomCSVPeriodYear = val
    },
    setCustomCSVPeriodMonth(val){
      this.CustomCSVPeriodMonth = val
    },
    addAccountingCode() {
      this.showAccountingForm = true
      this.action.ADD = true
      this.action.ADD_ONE = false
    },
    addAccountingCodeByItem(data) {
      this.selectedExpense = data
      this.showAccountingForm = true
      this.action.ADD_ONE = true
      this.action.ADD = false
    },  
    getAllAcounts() {
      try {
        this.$API.branchaccountcatalog
          .getActiveBranchAccountCatalog()
          .then(({ data }) => {
            this.accountList = data;
          });
      } catch (error) {
        console.log(error);
      }
    },
    handleAction({ action, ...data } = {}) {
      console.log(action)
      this.showAccountingForm = false
      if(action === "error") {
        this.showAlert("warning", "Advertencia", "Código contable seleccionado es invalido.")
      }
      else {
        if (this.action.ADD_ONE) {
          const expense = this.incomeExpenses.find(exp => exp.expenseIdCounter === this.selectedExpense.expenseIdCounter);

          if (expense) {
            expense.CatalogName = data.CatalogName
            expense.ID_AccountCatalog = data.ID_AccountCatalog
            expense.AccountCode = data.AccountCode
          }
        }

        if (this.action.ADD) {
          this.account = data
        }
      }
    },
    async getInfoBranch() {
      let idbusiness =
        JSON.parse(localStorage.getItem("user")).businessid || "";
      let idbranch = JSON.parse(localStorage.getItem("user")).branch || "";
      this.$API.branches
        .findSpecificBranch({ branch: idbranch, business: idbusiness })
        .then((res) => {
          const infobusiness = res[0];
          this.datatoprint.branch.AuthFeMode = infobusiness.AuthFeMode;
          this.datatoprint.branch.BusinessBillingNRC =
            infobusiness.BusinessBillingNRC;
          this.datatoprint.branch.BusinessBillingNIT =
            infobusiness.BusinessBillingNIT;
          this.datatoprint.branch.BusinessBillingName =
            infobusiness.BusinessBillingName;
          this.taxPayerSize = infobusiness.BusinessTaxPayerSize;
          this.BusinessLegalAgentRetain = infobusiness.LegalAgentRetain;
        });
    },
    removeIva(data) {
      setTimeout(() => {
        if (data.IsExento || data.IsNoSujeto) {
          // data.total = parseFloat(parseFloat(parseFloat(data.pricePerUnit * data.quantity) / 1.13).toFixed(4))
          data.total = parseFloat(this.calculateTotal(data.pricePerUnit, data.quantity));
        }
        else {
          data.total = parseFloat(this.calculateTotal(data.pricePerUnit, data.quantity));
        }
        
        this.$refs.gridContainer.instance.refresh();

        this.calculateGrandTotal();
      }, 0)
    },
    calculateHidrocarburo() {
      // Recalcular totales sumando todos los items marcados como hidrocarburos
      let totalFovial = 0;
      let totalCotrans = 0;

      if (this.incomeExpenses && this.incomeExpenses.length > 0) {
        this.incomeExpenses.forEach(item => {
          if (item.IsHidrocarburo && item.quantity > 0) {
            totalFovial += parseFloat(item.quantity * 0.2);
            totalCotrans += parseFloat(item.quantity * 0.1);
          }
        });
      }

      this.fovial = parseFloat(totalFovial.toFixed(2));
      this.cotrans = parseFloat(totalCotrans.toFixed(2));
    },
    getCatalogTypedocument() {
      this.$API.catalogtypedocument
        .getCatalogTypeDocumentForProvider()
        .then(({ data }) => {
          this.catalogTypedocument = data;
        });
    },
    
    onEditorChange(e) {
      this.invoice.InvoiceComment = e.html;
      if (this.invoice.InvoiceComment != "") {
        this.showBgcolorNotes = "tabsContent";
      } else if (
        this.invoice.InvoiceComment == "" ||
        this.invoice.InvoiceComment == "<p><br></p>"
      ) {
        this.showBgcolorNotes = "tabs";
      } else {
        this.showBgcolorNotes = "tabs";
      }
    },
    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    async acceptAlert() {
      this.alert.show = false;

      if (this.alert.options === "responseConfirmationBeforeSave") {
        await this.saveExpenseEntry();
      }

      if (this.alert.options === "responseConfirmationBeforeSave2") {
        await this.saveExpenseEntryFns();
      }
    },
    closeAlert() {
      this.alert.show = false;

      if (this.alert.options == "updateFinishAndPrintInvoice") {
        this.print2 = {
          show: true,
          data: { ...this.datatoprint },
          closeCallback: () => {
            this.$store.commit("posData/setReloaders", "reloadHistory");
          },
        };

        this.productsToShow = []
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    async confirmationBeforeSave() {
      // Validación: Al menos un proveedor
      if (!this.provider.ID_Provider) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue un proveedor de gasto para guardar la factura.`
        );
        return;
      }

      // Validación: Al menos un gasto
      if (!this.incomeExpenses || this.incomeExpenses.length === 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue gastos antes de guardar la factura.`
        );
        return;
      }

      // Validación: Cantidades y totales mayores a 0
      for (let item of this.incomeExpenses) {
        if (!item.quantity || parseFloat(item.quantity) <= 0) {
          this.showAlert(
            "warning",
            "Advertencia",
            `Todos los gastos deben tener una cantidad mayor a 0.`
          );
          return;
        }
        if (!item.total || parseFloat(item.total) <= 0) {
          this.showAlert(
            "warning",
            "Advertencia",
            `Todos los gastos deben tener un total mayor a 0.`
          );
          return;
        }
      }

      // Validación: Total general mayor a 0
      if (this.grandTotal == 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue precios y unidades respectivas antes de guardar la factura.`
        );
        return;
      }

      // Validación: Tipo de factura
      if (!this.invoice.InvoiceType) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione un tipo de factura en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Tipo de documento
      if (!this.invoice.InvoiceDocumentType && this.invoice.InvoiceType != 'FNS') {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione tipo de documento en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Correlativo
      if (!this.invoice.InvoiceCorrelative && this.invoice.InvoiceType != 'FNS') {
        this.showAlert(
          "warning",
          "Advertencia",
          `Ingrese el correlativo o código de generación en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Método de pago
      if (!this.invoice.InvoicePaymentMethod) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione un método de pago en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Estado de factura
      if (!this.invoice.InvoiceState) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione el estado de la factura en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Días de crédito si es a crédito
      if (this.invoice.InvoiceState === 'Crédito' && !this.invoice.InvoiceDays) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione los días de crédito en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Datos de exportación si es FE
      if (this.invoice.InvoiceType === 'FE' && (this.invoice.CodDocAsociado === null || this.invoice.CodDocAsociado === "") && 
          (this.invoice.DocAsociado === null || this.invoice.DocAsociado === "") && 
          (this.invoice.DetalleDocAsociado === null || this.invoice.DetalleDocAsociado === "")) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "Faltan datos requeridos a completar para la factura de exportación"
        );
        return;
      }

      // Validación: Período CSV personalizado
      if (this.CustomCSVPeriodFlag) {
        let errors = 0;
        
        this.submitCustomCSVPeriodState = true;
        !this.CustomCSVPeriodMonth && (errors += 1);
        !this.CustomCSVPeriodYear && (errors += 1);

        if (errors > 0) {
          this.showAlert(
            "warning",
            "Advertencia",
            "Debe llenar todos los campos obligatorios"
          );
          return;
        }
      }

      // Validación de cuentas contables
      if (this.incomeExpenses) {
        let tmpShowAlert = false
        for (let item of this.incomeExpenses) {
          if (item.ID_AccountCatalog == null || item.CatalogName == null) {
            tmpShowAlert = true
            break
          }
        }

        if (tmpShowAlert) {
          this.showAlert(
            "question2",
            "Advertencia",
            `La factura contiene elementos sin cuenta contable asignada. ¿Quiere guardar el comprobante sin asignar las cuentas contable?`,
            "responseConfirmationBeforeSave"
          );
        }
        else {
          await this.saveExpenseEntry()
        }
      }
      else {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue gastos para guardar la factura.`
        );
        return;
      }
    },
    async saveExpenseEntry() {
      if (this.checkImageSize()) return;
      
      // Validación: Al menos un proveedor
      if (!this.provider.ID_Provider) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue un proveedor de gasto para guardar la factura.`
        );
        return;
      }

      // Validación: Al menos un gasto agregado
      if (!this.incomeExpenses || this.incomeExpenses.length === 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue gastos para guardar la factura.`
        );
        return;
      }

      // Validación: Total general debe ser mayor a cero
      if (this.grandTotal <= 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `El total general debe ser mayor a cero.`
        );
        return;
      }

      // Validación: Cantidad de cada item debe ser mayor a cero
      const itemWithZeroQuantity = this.incomeExpenses.find(item => !item.quantity || item.quantity <= 0);
      if (itemWithZeroQuantity) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Todos los gastos deben tener una cantidad mayor a cero.`
        );
        return;
      }

      // Validación: Total de cada item debe ser mayor a cero
      const itemWithZeroTotal = this.incomeExpenses.find(item => !item.total || item.total <= 0);
      if (itemWithZeroTotal) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Todos los gastos deben tener un total mayor a cero.`
        );
        return;
      }

      if (this.grandTotal == 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue precios y unidades respectivas antes de guardar la factura.`
        );
        return;
      }

      if (!this.invoice.InvoiceType) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione un tipo de factura en la sección de datos de la factura.`
        );
        return;
      }

      if (!this.invoice.InvoiceDocumentType && this.invoice.InvoiceType != 'FNS') {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione tipo de documento en la sección de datos de la factura.`
        );
        return;
      }

      if (!this.invoice.InvoiceCorrelative && this.invoice.InvoiceType != 'FNS') {
        this.showAlert(
          "warning",
          "Advertencia",
          `Ingrese el correlativo o código de generación en la sección de datos de la factura.`
        );
        return;
      }

      if (!this.invoice.InvoicePaymentMethod) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione un método de pago en la sección de datos de la factura.`
        );
        return;
      }

      if (!this.invoice.InvoiceState) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione el estado de la factura en la sección de datos de la factura.`
        );
        return;
      }

      if (this.invoice.InvoiceState === 'Crédito' && !this.invoice.InvoiceDays) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione los días de crédito en la sección de datos de la factura.`
        );
        return;
      }

      if ( this.invoice.InvoiceType === 'FE' && (this.invoice.CodDocAsociado === null || this.invoice.CodDocAsociado === "") && 
      (this.invoice.DocAsociado === null || this.invoice.DocAsociado === "") && 
      (this.invoice.DetalleDocAsociado === null || this.invoice.DetalleDocAsociado === "")) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "Faltan datos requeridos a completar para la factura de exportación"
        )
        return;
      }


      if( this.CustomCSVPeriodFlag ) {
        let errors = 0;
        
        this.submitCustomCSVPeriodState = true;
        !this.CustomCSVPeriodMonth && ( errors += 1 );
        !this.CustomCSVPeriodYear && ( errors += 1 );

        if (errors > 0) {
          this.showAlert(
            "warning",
            "Advertencia",
            "Debe llenar todos los campos obligatorios"
          );
          return;
        }
      }

      /*if (this.incomeExpenses.find(item => item.ExpenseName == 'Ingresar nombre de gasto aquí' 
      || item.ExpenseName?.trim() === '' || item.ExpenseName == null)) {
        this.showAlert(
          "warning",
          "Advertencia", 
          "Falta detallar el nombre de los gastos ingresados"
        )
        return;
      }*/
      //console.log(this.incomeExpenses);

      const formData = new FormData()

      const expensesEntry = {
        ID_Provider: this.provider.ID_Provider,
        ID_AccountCatalog: null,
        CatalogName: null,
        ExpenseInvoiceDate: this.invoice.InvoiceDate,
        ExpenseInvoiceType: this.invoice.InvoiceType,
        ExpenseInvoiceDocumentType: this.invoice.InvoiceDocumentType,
        ExpenseInvoiceId: this.invoice.InvoiceCorrelative,
        ExpenseInvoiceNumeroControl: this.invoice.NumeroControl,
        ExpenseInvoicePayment: this.invoice.InvoicePaymentMethod,
        ExpenseInvoiceStatus: this.invoice.InvoiceState,
        ExpenseInvoiceCreditDays: this.invoice.InvoiceDays,
        ExpenseInvoiceComment: this.invoice.InvoiceComment,
        Iva: this.iva,
        Exentas: this.exentas,
        NoSujetas: this.nosujetas,
        ReteRenta: this.reterenta,
        IvaRet: this.ivaret,
        IvaPerc: this.ivaperc,
        Fovial: this.fovial,
        Cotrans: this.cotrans,
        Flete: this.flete,
        Seguro: this.seguro,
        SubTotal: this.subTotal,
        TotalExpense: this.grandTotal,
        CodDocAsociado: this.invoice.CodDocAsociado,
        DocAsociado: this.invoice.DocAsociado,
        DetalleDocAsociado: this.invoice.DetalleDocAsociado,
        PercentageIVA: this.percentageIvaCheck ? this.percentageIva : null,
        CustomCSVPeriodFlag: this.CustomCSVPeriodFlag,
        CustomCSVPeriodYear: this.CustomCSVPeriodYear,
        CustomCSVPeriodMonth: this.CustomCSVPeriodMonth,
        ClasificationRent: this.invoice.ClasificationRent,
        TipoIngresoProveedores: this.invoice.TipoIngresoProveedores,
        SectorProveedores: this.invoice.SectorProveedores,
        NumeroDocumentoRelacionado: this.invoice.InvoiceType === 'NC' ? this.invoice.NumeroDocumentoRelacionado : null,
        selloRecibido: this.invoice.SelloRecibido || null
      };
      
      formData.append("expensesEntry", JSON.stringify(expensesEntry))
      formData.append("file", this.image)

      
      await this.saveAccountingExpenseEntry(formData, this.incomeExpenses);

      this.clear();
    },
    async beforeSaveExpenseEntryFns() {
      // Validación de cuentas contables
      if (this.incomeExpenses) {
        let tmpShowAlert = false
        for (let item of this.incomeExpenses) {
          if (item.ID_AccountCatalog == null || item.CatalogName == null) {
            tmpShowAlert = true
            break
          }
        }

        if (tmpShowAlert) {
          this.showAlert(
            "question2",
            "Advertencia",
            `La factura contiene elementos sin cuenta contable asignada. ¿Quiere guardar el comprobante sin asignar las cuentas contable?`,
            "responseConfirmationBeforeSave2"
          );
        }
        else {
          await this.saveExpenseEntryFns()
        }
      }
      else {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue gastos para guardar la factura.`
        );
        return;
      }
    },
    async saveExpenseEntryFns() {
      if (this.checkImageSize()) return;

      // Validación: Al menos un proveedor
      if (!this.provider.ID_Provider) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue un proveedor de gasto para guardar la factura.`
        );
        return;
      }

      // Validación: Al menos un gasto agregado
      if (this.incomeExpenses === null || this.incomeExpenses === undefined || this.incomeExpenses.length === 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Agregue gastos para guardar la factura.`
        );
        return;
      }

      // Validación: Total general debe ser mayor a cero
      if (this.grandTotal <= 0) {
        this.showAlert(
          "warning",
          "Advertencia",
          `El total general debe ser mayor a cero.`
        );
        return;
      }

      // Validación: Cantidad de cada item debe ser mayor a cero
      const itemWithZeroQuantity = this.incomeExpenses.find(item => !item.quantity || item.quantity <= 0);
      if (itemWithZeroQuantity) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Todos los gastos deben tener una cantidad mayor a cero.`
        );
        return;
      }

      // Validación: Total de cada item debe ser mayor a cero
      const itemWithZeroTotal = this.incomeExpenses.find(item => !item.total || item.total <= 0);
      if (itemWithZeroTotal) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Todos los gastos deben tener un total mayor a cero.`
        );
        return;
      }

      // Validación: Tipo de comprobante/factura
      if (!this.invoice.InvoiceType) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione un tipo de comprobante en la sección de datos de la factura.`
        );
        return;
      }

      // Validación: Tipo de documento
      // if (!this.invoice.InvoiceDocumentType && this.invoice.InvoiceType != 'FNS') {
      //   this.showAlert(
      //     "warning",
      //     "Advertencia",
      //     `Seleccione tipo de documento en la sección de datos de la factura.`
      //   );
      //   return;
      // }

      /*if (this.invoice.InvoiceCorrelative === null || this.invoice.InvoiceCorrelative === "") {
        this.showAlert(
          "warning",
          "Advertencia",
          `Ingrese el correlativo o código de generación en la sección de datos de la factura.`
        );
        return;
      }*/

      // Validación: Método de pago
      if (!this.invoice.InvoicePaymentMethod) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione un método de pago en la sección de datos de la factura.`
        );
        return;
      }

      if (!this.invoice.InvoiceState) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione el estado de la factura en la sección de datos de la factura.`
        );
        return;
      }

      if (this.invoice.InvoiceState === 'Crédito' && !this.invoice.InvoiceDays) {
        this.showAlert(
          "warning",
          "Advertencia",
          `Seleccione los días de crédito en la sección de datos de la factura.`
        );
        return;
      }

      if ( this.invoice.InvoiceType === 'FE' && (this.invoice.CodDocAsociado === null || this.invoice.CodDocAsociado === "") && 
      (this.invoice.DocAsociado === null || this.invoice.DocAsociado === "") && 
      (this.invoice.DetalleDocAsociado === null || this.invoice.DetalleDocAsociado === "")) {
        this.showAlert(
          "warning", 
          "Advertencia", 
          "Faltan datos requeridos a completar para la factura de exportación"
        )
        return;
      }

      let obj = {
        invoicedate: this.invoice.InvoiceDate,
        invoicetype: this.invoice.InvoiceType,
        idinvoice: null,
        invoiceidinvoice: "No hay correlativo",
        invoiceisnontaxable:
          this.provider.ProviderLegalIsNonTaxable == "" ||
          this.provider.ProviderLegalIsNonTaxable == null
            ? 0
            : 1,
        invoiceisnonsuj: 0,
        istemplate: 0,
        isquote: 0,
        timesexecute: 0,
        idbusiness: JSON.parse(localStorage.getItem("user")).businessid,
        idbranch: JSON.parse(localStorage.getItem("user")).branch,
        idcustomer: this.provider.ID_Provider,
        firstname: null,
        lastname: null,
        phonenumber: null,
        mobilenumber: null,
        email: null,
        gender: null,
        age: null,
        dateofbirth: null,
        address: null,
        city: this.provider.ProviderCity,
        state: this.provider.ProviderState,
        country: this.provider.ProviderCountry,
        notes: this.invoice.InvoiceComment,
        status: 1,
        sendemail: 0,
        sendsms: 0,
        sendwhatsapp: 0,
        sendpushup: 0,
        isa_business: true,
        businessname: this.provider.ProviderLegalName,
        businessphone: this.provider.ProviderPhone,
        businessmobilenumber: this.provider.ProviderMobileNumber,
        businessemail: this.provider.ProviderEmail,
        businesscontactname: this.provider.ProviderContactName,
        businesscontactphone: this.provider.ProvicerContactPhone,
        businesscontactmobile: this.provider.ProviderContactMobile,
        businesscontactemail: this.provider.ProviderContactEmail,
        businesswebsite: null,
        sendemailbusinessemail: 0,
        sendsmsbusinessmobile: 0,
        sendwhatsappbusinessmobile: 0,
        invoicename: this.provider.ProviderLegalName,
        invoiceaddress: this.provider.ProviderLegalAddress,
        invoicenrc: this.provider.ProviderLegalNRC,
        invoicenit: this.provider.ProviderLegalNIT,
        dui: null,
        invoicesector: this.provider.ProviderLegalSector,
        invoiceentity: this.provider.ProviderLegalEntity,
        invoicetaxpayersize: this.provider.ProviderLegalTaxPayerSize,
        invoiceinfo: null,
        iduser_insert: null,
        iduser_update: null,
        department: this.provider.ProviderState,
        municipality: this.provider.ProviderCity,
        codactividad: null,
        descactividad: null,
        iddocumenttype: 2,
        prefijo: null,
        pricelistname: null,
        limitcredit: 0,
        itemtext: this.provider.ProviderLegalName,
        invoicepaymenttype: this.invoice.InvoicePaymentMethod,
        invoicestatusdescription: this.invoice.InvoiceState,
        invoicecreditday: this.invoice.InvoiceDays,
        invoicestatus: 1,
        invoicedescunosuj: 0,
        invoicedescuexenta: 0,
        invoicedescugravada: 0,
        invoiceporcentajedescuento: 0,
        invoicetotaldescu: 0,
        invoicesubtotalventas: parseFloat(
          parseFloat(this.subTotal).toFixed(2)
        ),
        invoicesubtotal: parseFloat(parseFloat(this.subTotal).toFixed(2)),
        invoicemontototaloperacion: parseFloat(
          parseFloat(this.subTotal).toFixed(2)
        ),
        invoicetotalexenta: this.exentas,
        invoicetotalnosuj: this.nosujetas,
        invoicetotalgravada: parseFloat(parseFloat(this.subTotal).toFixed(2)),
        invoicetotalpagar: parseFloat(parseFloat(this.grandTotal).toFixed(2)),
        invoicetotaliva: 0,
        invoiceivarete1: 0,
        invoiceivaperce1: 0,
        invoicetotalletras: numberToText(this.grandTotal),
        invoicedui: null,
        invoicereterenta: parseFloat(parseFloat(this.reterenta).toFixed(2)),
        codpointsale: localStorage.getItem("codPointSale"),
        clasificationrent: this.invoice.ClasificationRent,
        tipoingresoproveedores: this.invoice.TipoIngresoProveedores,
        sectorproveedores: this.invoice.SectorProveedores,
      };

      let payment = {};
      payment.typePayment = this.paymentTypes.find(
        (element) => element.Valores === this.invoice.InvoicePaymentMethod
      ).Codigo;
      payment.descriptionPayment = this.invoice.InvoicePaymentMethod;
      payment.totalPayment = obj.invoicetotalpagar;
      if (
        this.invoice.InvoicePaymentMethod != "Billetes y monedas" &&
        this.invoice.InvoicePaymentMethod != undefined
      ) {
        payment.reference = this.invoice.InvoiceReference;
      } else {
        payment.reference = null;
      }

      let payments = [];
      payments.push(payment);

      obj.payments = payments;
      console.log(this.incomeExpenses)
      // return;
      let items = this.incomeExpenses.map((i) => {
        let total_price = parseFloat(i.total);
        let iva = parseFloat(total_price - total_price / 1.13);
        //let ivaret = 0;

        return {
          idbranch: JSON.parse(localStorage.getItem("user")).branch,
          idbusiness: JSON.parse(localStorage.getItem("user")).businessid,
          iditem: "GASTO",
          itemtype: i.ExpenseType,
          itemquantity: i.quantity,
          itemmeasureunit: "",
          itemdescription: i.ExpenseName,
          itemunitcost: parseFloat(parseFloat(i.pricePerUnit).toFixed(8)),
          itemdiscount: 0,
          itemdiscountpercent: 0,
          itemnosuj: i.IsExento ? parseFloat(total_price / 1.13).toFixed(8) : 0,
          itemexenta: i.IsNoSujeto ? parseFloat(total_price / 1.13).toFixed(8) : 0,
          itemgravada: (i.IsExento == false && i.IsNoSujeto == false) ? parseFloat(parseFloat(total_price).toFixed(8)) : 0,
          itempsv: 0,
          itemnogravada: 0,
          itemiva: iva,
          itemcurrency: "$",
          expirationdate: "",
          itembatch: "",
          warehouse: "",
          barcode: "",
          ID_AccountCatalog: i.ID_AccountCatalog
        };
      });
      this.loading = true;

      this.$API.invoices
        .createInvoice({
          header: obj,
          items: items,
          user: JSON.parse(localStorage.getItem("user")).id,
          invalid: null,
          ndornc: null,
          contingency: null,
          UseReserveWarehouse: 0,
          ShowCorrelativeControl: 0,
          UseNewSpNumControl: 0,
          ServicioDeProPinas: null
        })
        .then(async (resp) => {
          this.loading = false;

          if (resp?.success) {
            let response = resp.data
            this.datatoprint.dteJson = response.billingDteJsonHeader || null;

            if (response.sendBill == 1) {
              if (response.estado == "PROCESADO") {
              let mensaje = "";
              mensaje = "Se ha realizado y procesado la factura.<br/><br/>";
              mensaje += "Estado: " + response.estado + "<br/>";
              mensaje +=
                "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
              mensaje += "Observaciones DTE: <br/>";
              if (response.observaciones.length == 0) {
                mensaje += "- Ninguna observación <br/>";
              } else {
                for (let i = 0; i < response.observaciones.length; i++) {
                  mensaje += "- " + response.observaciones[i] + "<br/>";
                }
              }

              this.datatoprint.header = await this.$API.invoices.getInvoice(
                response.billingDteJsonHeader.ID_Invoice
              );
              this.datatoprint.body = await this.$API.invoices.getAllInvoiceItems(
                response.billingDteJsonHeader.ID_Invoice
              );

              this.clear();

              //console.log("VEAMOS", this.datatoprint)
              this.showAlert(
                "successHtml",
                "Factura generada",
                mensaje,
                "updateFinishAndPrintInvoice"
              );
            } else if (response.estado == "CONTINGENCIA") {
              let mensaje = "";
              mensaje = `La factura se ha guardado en estado de contingencia.<br/><br/>`;
              mensaje += "Estado: " + response.estado + "<br/>";
              mensaje +=
                "Error del DTE: <br/> - " +
                response.status +
                ", " +
                response.error +
                "<br/>";
              this.datatoprint.header = await this.$API.invoices.getInvoice(
                response.billingDteJsonHeader.ID_Invoice
              );
              this.datatoprint.body = await this.$API.invoices.getAllInvoiceItems(
                response.billingDteJsonHeader.ID_Invoice
              );
              
              this.clear();
              
              this.showAlert(
                "successHtml",
                "Factura generada",
                mensaje,
                "updateFinishAndPrintInvoice"
              );
            } else {
              let mensaje =
                "Se ha rechazado la factura, tomar en cuenta las observaciones del Ministerio de Hacienda y realizarla de nuevo.<br/><br/>";
              mensaje += "Estado: " + response.estado + "<br/>";
              mensaje +=
                "Mensaje del DTE: <br/> - " + response.descripcionMsg + "<br/>";
              mensaje += "Observaciones DTE: <br/>";
              if (response.observaciones.length == 0) {
                mensaje += "- Ninguna observación <br/>";
              } else {
                for (let i = 0; i < response.observaciones.length; i++) {
                  mensaje += "- " + response.observaciones[i] + "<br/>";
                }
              }
              this.showAlert("successHtml", "Factura rechazada", mensaje);
            }  
            } else {
              let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)";
              this.showAlert("warning", "Advertencia", message);
            }
          }
          else if (!resp?.success) {
            let response = resp.data

            if (resp?.lockdata) {
              let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
              this.showAlert("warning", "Información", message);
            }
            else if (resp?.typeError == "InventoryError") {
              if (response?.message) {
                let message = 'No se puede crear el comprobante, se encontraron los siguientes errores: <br/><br/> '
                message += typeof response === 'string' ? response : response?.message ?? '';
                this.showAlert("dangerHtml", "Advertencia", message)
              }
              else {
                let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
                this.showAlert("warning", "Información", message);
              }
            }
            else if (response?.typeError == "DteError") {
              let message = `Ha ocurrido un problema al momento de generar el correlativo del número de control, el sistema ha procedido a hacer la corrección en este momento.
                <br/><br/>
                Favor hacer clic nuevamente en Facturar para enviar el documento tributario electrónico`                      
              this.showAlert("dangerHtml", "Advertencia", message)
            }
            else {
              let message = response.message || "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
              this.showAlert("warning", "Advertencia", message);
            }
          }
        })
        .catch(() => {
          this.loading = false;
          let message = "Se perdio la conexión, espere un momento y vuelva a intentarlo (Verifique su conexión a internet)"
          this.showAlert("warning", "Advertencia", message);
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveAccountingExpenseEntry(expensesEntry, expensesEntryDetail) {
      this.loading = true;
      this.$API.accountingexpensesentry
        .createAccountingExpensesEntry(expensesEntry)
        .then((data) => {
          this.saveAccountingExpenseEntryDetail(expensesEntryDetail, data.ID);
        })
        .catch((error) => {
          this.loading = false;
          this.showAlert("danger", "Error", `${error}`);
        });
    },
    saveAccountingExpenseEntryDetail(expensesEntryDetail, ID_Entry) {
      this.$API.accountingexpensesentrydetail
        .createAccountingExpensesEntryDetail({ 
          expensesEntryDetail, 
          ID_Entry
        })
        .then(() => {
          this.loading = false;
          this.showAlert(
            "success",
            "Ingreso de gasto de agregado",
            `Se agregó el ingreso de gasto correctamente`
          );
        })
        .catch((error) => {
          this.loading = false;
          this.showAlert("danger", "Error", `${error}`);
        });
    },
    getAllExpense() {
      this.$API.accountingexpenses
        .getAllAccountingExpenses()
        .then(({ data }) => {
          this.expenses = data;
        })
        .catch((error) => console.log(error));
    },
    getAllProviders() {
      this.$API.accountingexpenses
        .getAllProvidersExpenses()
        .then(({ data }) => {
          this.providers = data;
        })
        .catch((error) => console.log(error));
    },
    filterHandler({ data }) {
      this.expenses = data[0];
    },
    filterHandlerExpense({ data }) {
      this.expenses = data[0];
    },
    addExpense(expense) {
      let findExpense;
      if (this.isNumber(expense)) {
        // When it was sent from v-dialog as a number (ID)
        expense = this.expenses.find((item) => item.ID === expense);
        findExpense = this.checkIfAlreadyExistInTable(expense);
      } else {
        // When it was sent from table component as an object
        findExpense = this.checkIfAlreadyExistInTable(expense);
      }

      // If it was already add in the table, add it
      if (!findExpense) {
        expense.pricePerUnit = 0;
        expense.quantity = 1;
        expense.IsExento = false;
        expense.IsNoSujeto = false;
        expense.total = 0;
        this.incomeExpenses.push(expense);
      }   
      this.insertCode = null;
    },
    addExpense2() {
      let expense = {
        expenseIdCounter: this.expenseIdCounter++,
        ID_AccountCatalog: null,
        CatalogName: null,
        AccountCode: null,
        ExpenseType: 'product',
        ExpenseName: 'Ingresar nombre de gasto aquí',
        pricePerUnit: 0,
        quantity: 1,
        IsExento: false,
        IsNoSujeto: false,
        ItemDeclarationType: 2,
        total: 0,
      }
      
      this.incomeExpenses.push(expense);
      console.log(this.incomeExpenses);
    },
    checkIfAlreadyExistInTable(expense) {
      return this.incomeExpenses.find((incomeExpense) => incomeExpense.ID === expense.ID);
    },
    addProvider(data) {
      this.provider = data;
      this.showExpenseSuppliers = false
    },
    removeRow(data) {
      const index = this.incomeExpenses.findIndex((income) => income.expenseIdCounter === data.expenseIdCounter);
      if (index !== -1) {
        this.incomeExpenses.splice(index, 1);
        this.calculateHidrocarburo();
      }
    },
    isNumber(value) {
      return typeof value === "number";
    },
    calculateTotalOnEnter() {
      this.incomeExpenses.map((incomeExpense) => {
        if (incomeExpense.IsExento || incomeExpense.IsNoSujeto) {
          // incomeExpense.total = parseFloat(
          //   parseFloat(
          //     parseFloat(this.calculateTotal(incomeExpense.pricePerUnit, incomeExpense.quantity)) / 1.13
          //   ).toFixed(4)
          // );
          incomeExpense.total = parseFloat(
            this.calculateTotal(incomeExpense.pricePerUnit, incomeExpense.quantity)
          ).toFixed(4)
        }
        else {
          if ((this.invoice.InvoiceType == 'CCF' || this.invoice.InvoiceType == 'NC')) {
            incomeExpense.total = parseFloat(
              this.calculateTotal(incomeExpense.pricePerUnit, incomeExpense.quantity)
            )
            // let total = parseFloat(this.calculateTotal(incomeExpense.pricePerUnit, incomeExpense.quantity)) 
            // incomeExpense.total = parseFloat(
            //   total + (total * 0.13)
            // );
          }
          else {
            incomeExpense.total = parseFloat(
              this.calculateTotal(incomeExpense.pricePerUnit, incomeExpense.quantity)
            );
          }
        }
      });
      this.calculateHidrocarburo();
      this.calculateGrandTotal();
    },
    calculateTotal(price, quantity) {
      if (this.isNumber(price) && this.isNumber(quantity)) {
        return parseFloat(price * quantity).toFixed(2);
      }
      return "error";
    },
    calculateGrandTotal() {
      let subTotal = 0;
      let iva = 0;
      let exentas = 0;
      let nosujetas = 0;
      let reterenta = 0;
      let ivaret = 0;
      let ivaperc = 0;
      
      for (const item of this.incomeExpenses) {
        // Inicializar campos de impuestos del ítem para registrar en BD
        item.NetoUnitario = 0;
        item.Iva = 0;
        item.ReteRenta = 0;
        item.Exentas = 0;
        item.NoSujetas = 0;
        item.Fovial = 0;
        item.Cotrans = 0;
        
        const itemTotal = parseFloat(item.total);
        
        // Calcular FOVIAL y COTRANS si es hidrocarburo
        if (item.IsHidrocarburo) {
          item.Fovial = parseFloat((item.quantity * 0.2).toFixed(2));
          item.Cotrans = parseFloat((item.quantity * 0.1).toFixed(2));
        }
        
        if (item.IsExento) {
          item.Exentas = itemTotal;
          item.NetoUnitario = itemTotal;
          exentas += itemTotal;
        }
        else if (item.IsNoSujeto) {
          item.NoSujetas = itemTotal;
          item.NetoUnitario = itemTotal;
          nosujetas += itemTotal;
        }
        else {
          if (this.invoice.InvoiceType == 'CCF' || this.invoice.InvoiceType == 'NC') {
            // CCF: El total NO incluye IVA, se calcula y suma
            item.NetoUnitario = itemTotal;
            item.Iva = parseFloat((itemTotal * 0.13).toFixed(2));
            subTotal += itemTotal;
            iva += parseFloat(itemTotal * 0.13);
            
            if (item.ExpenseType == "service" && this.provider.LegalReteRenta) {
              item.ReteRenta = parseFloat((itemTotal * 0.1).toFixed(2));
              reterenta += parseFloat(itemTotal * 0.1);
            }
          }
          else {
            // FCF/FE/FNS: El total incluye IVA
            item.NetoUnitario = parseFloat((itemTotal / 1.13).toFixed(2));
            item.Iva = parseFloat((itemTotal - item.NetoUnitario).toFixed(2));
            subTotal += itemTotal;
            iva += parseFloat(itemTotal - parseFloat(itemTotal / 1.13));

            if (this.invoice.InvoiceType == 'FCF') {
              if (item.ExpenseType == "service" && this.provider.LegalReteRenta) {
                item.ReteRenta = parseFloat((parseFloat(itemTotal / 1.13) * 0.1).toFixed(2));
                reterenta += parseFloat(parseFloat(itemTotal / 1.13) * 0.1);
              }
            }
          }

          if (this.invoice.InvoiceType == 'FNS') {
            if (item.ExpenseType == "service") {
              console.log( 'fns, service ', itemTotal * 0.1 );
              item.ReteRenta = parseFloat((itemTotal * 0.1).toFixed(2));
              reterenta += parseFloat(itemTotal * 0.1);
            }
          }
        }
      }

      
      if (this.invoice.InvoiceType == 'FCF') {
        if (this.BusinessLegalAgentRetain && !this.provider.LegalAgentRetain) {
          if (subTotal >= 113) {
            let subTotalLessIva = parseFloat(parseFloat(subTotal) / 1.13);
            ivaret = parseFloat(parseFloat(subTotalLessIva) * 0.01)
          } 
        }
      }

      if (this.invoice.InvoiceType == 'CCF' || this.invoice.InvoiceType == 'NC') {
        if (!this.BusinessLegalAgentRetain && this.provider.LegalAgentRetain) {
          if (subTotal >= 100) {
            ivaperc = parseFloat(parseFloat(subTotal) * 0.01)
          }

          ivaret = 0
        }

        if (this.BusinessLegalAgentRetain && !this.provider.LegalAgentRetain) {
          if (subTotal >= 100) {
            ivaret = parseFloat(parseFloat(subTotal) * 0.01)
          }

          ivaperc = 0
        }
      }

      this.subTotal = subTotal.toFixed(2);
      this.iva = iva.toFixed(2);
      this.exentas = exentas.toFixed(2);
      this.nosujetas = nosujetas.toFixed(2);
      this.reterenta = reterenta.toFixed(2);
      this.ivaret = ivaret.toFixed(2);
      this.ivaperc = ivaperc.toFixed(2);

      if (this.invoice.InvoiceType == "CCF" || this.invoice.InvoiceType == 'NC') {
        this.grandTotal = parseFloat(
          subTotal + iva + exentas + nosujetas - reterenta - ivaret + ivaperc + parseFloat(this.fovial) + parseFloat(this.cotrans)
        ).toFixed(2)
      }
      else if (this.invoice.InvoiceType == "FE"){
        this.grandTotal = parseFloat(
          subTotal + exentas + nosujetas - reterenta - ivaret + ivaperc + parseFloat(this.fovial) + parseFloat(this.cotrans) 
          + parseFloat(this.flete) + parseFloat(this.seguro)
        ).toFixed(2)
      }
      else {
        this.grandTotal = parseFloat(
          subTotal + exentas + nosujetas - reterenta - ivaret + ivaperc + parseFloat(this.fovial) + parseFloat(this.cotrans)
        ).toFixed(2)
      }
      
    },
    clear() {
      this.incomeExpenses = [];
      this.provider = {};
      this.percentageIvaCheck = false;
      this.percentageIva = 50;
      this.account = {}
      this.invoice = {
        InvoiceDate: moment().format("DD/MM/YYYY"),
        InvoiceType: "",
        InvoiceCorrelative: "",
        NumeroControl: "",
        SelloRecibido: "",
        InvoiceDocumentType: "",
        InvoicePaymentMethod: "",
        InvoiceState: "",
        InvoiceComment: "",
        InvoiceDays: "",
        NumeroDocumentoRelacionado: "",
        ID_AccountCatalog: null,
        TipoIngresoProveedores: null,
        SectorProveedores: null,
        ClasificationRent: '2',
      }
      this.cleanState = true
    },
    maxFileSize(event) {
      const allowedSize = 2 * 1024 * 1024; // 2 MB in bytes
      const fileSize = event.size;

      if (fileSize > allowedSize) {
        this.validImageSize = false;
        return `El tamaño del archivo debe ser menor a 2 Mb`;
      }

      this.validImageSize = true;
      return true;
    },
    checkImageSize() {
      if (this.validImageSize == false) {
        this.showAlert("danger", "Error", "El tamaño de la imagen debe ser menor a 2 Mb");
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.bar {
  width: 100%;
  background-color: rgb(60, 60, 60) !important;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-radius: 15px !important;
  margin-top: 1rem !important;
}

.box {
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 3px;
  border: 1px solid;
  border-color: black;
}

.border {
  border-radius: 15px !important;
}

.btnsave {
  background-color: #00a178 !important;
  color: white;
}

.btnclean {
  background-color: #f29d35 !important;
  color: white;
  margin: 0;
  padding: 0;
}

.btn-add {
  background-color: #3498db !important;
  color: white;
}

.close-btn {
  color: white !important;
  position: relative !important;
  float: right !important;
}

.btndisable {
  background-color: #41464c !important;
  color: white;
}

.totalDesign {
  background-color: #00a178 !important;
  font-weight: bold !important;
  color: white !important;
  font-size: 25px;
  max-width: 165px !important;
}

.formControl {
  background: #d6eaf3;
  border: 1px solid #1976d2;
  text-align: center;
  max-width: 80px;
  height: 30px;
  border-radius: 20px;
}
.totalText {
  font-size: 16px;
  margin-bottom: 5px;
}

.minimize {
  display: flex;
  min-width: calc(100% - 100px);
  background: #41464c;
  color: white;
  bottom: 0;
  left: auto;
  z-index: 4; /*99999999;*/
  justify-content: center;
}

.maximize {
  display: flex;
  width: calc(100% - 300px);
  background: #41464c;
  color: white;
  bottom: 0;
  left: auto;
  z-index: 4; /*99999999;*/
  justify-content: center;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}
.break-line {
  display: none; /* Oculta por defecto */
}

@media (max-width: 910px) { 
  .break-line {
    display: block;
    width: 100%;
    height: 10px; /* Mantiene el div sin altura */
  }
}

.break-line2 {
  display: none; /* Oculta por defecto */
}

@media (max-width: 379px) { 
  .break-line2 {
    display: block;
    width: 100%;
    height: 10px; /* Mantiene el div sin altura */
  }
}

@media (min-width: 600px) and (max-width: 720px){ 
  .spaced {
    margin-right: 20px;
  }
}

@media (min-width: 520px) and (max-width: 599px){ 
  .spaced {
    margin-right: 40px;
  }
}
@media (min-width: 440px) and (max-width: 519px){ 
  .spaced {
    margin-right: 55px;
  }
}
@media (min-width: 380px) and (max-width: 439px){ 
  .spaced {
    margin-right: 65px;
  }
}
</style>
